
export const allowedMethodsService = async (welletContext, email, tenantId) => {
  return await welletContext.apis.tickets.get(`/users/login/allowed-methods?email=${email}&tenantId=${tenantId}`);
};

